/**
 * @file ppde页成员组件
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import classNames from 'classnames';

import {IMemberItemProps} from './types';
import A from '../../../../components/a/A';

const MemberItem: React.FC<IMemberItemProps> = (props) => {
    const {
        name,
        className,
        backgroundType,
        size,
        img,
        company,
        position,
        link
    } = props;

    return (
        <A
            href={link}
            target
        >
            <div className={classNames(
                `paddle-ppde-members-item`,
                {
                    'paddle-ppde-members-item-type-d': !backgroundType || backgroundType === 1 || backgroundType === 'd',
                    'paddle-ppde-members-item-type-e': backgroundType === 2 || backgroundType === 'e',
                    'paddle-ppde-members-item-type-p': backgroundType === 3 || backgroundType === 'p',
                    'paddle-ppde-members-item-large': size === 'large'
                },
                className
            )}>
                <div
                    className="paddle-ppde-members-item-img"
                    style={{backgroundImage: img ? `url(${img})` : undefined}}
                />
                <div className="paddle-ppde-members-item-info">
                    <div className="paddle-ppde-members-item-info-inner">
                        <div className="paddle-ppde-members-item-title">
                            {name}
                        </div>
                        <div className="paddle-ppde-members-item-texts">
                            <div className="paddle-ppde-members-item-text">
                                {company}
                            </div>
                            <div className="paddle-ppde-members-item-text">
                                {position}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </A>
    );
};

export default MemberItem;
